// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ClaimDetailsResponseModel } from './claimDetailsResponseModel.js';
import type { GatewayMedicalClaimModel } from './gatewayMedicalClaimModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalClaimSearchResponseModel {
    'claim': GatewayMedicalClaimModel | null;
    'claimDetails'?: ClaimDetailsResponseModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalClaimSearchResponseModel>> = [
        {
            "name":     "claim",
            "baseName": "claim",
            "type":     "GatewayMedicalClaimModel"
        },
        {
            "name":     "claimDetails",
            "baseName": "claimDetails",
            "type":     "ClaimDetailsResponseModel"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalClaimSearchResponseModel.attributeTypeMap;
    }
}
